export function zeroFill(value: number, length: number): string {
  const stringValue = Math.abs(value).toString();

  if (stringValue.length >= length) {
    return stringValue;
  }

  const countZero = length - stringValue.length;
  const arrayZero = Array(countZero).fill('0');

  const result = arrayZero.join() + stringValue;

  return value < 0 ? `-${result}` : result;
}
